// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__1qnjH","hiden":"Table_hiden__3ha_L"};